import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("button", component(opts));
  editor.BlockManager.add("button", block(opts));
};